import React from 'react'
import DefaultAva from 'assets/icon/default-ava.jpeg'
import Cookie from 'universal-cookie'
import { logout } from 'redux/actions/auth'
import { useDispatch } from 'react-redux'
const cookie=new Cookie()
const profile=cookie.get('profile_cookie_forum')
export default function Profile() {
    const dispatch = useDispatch()
    const onLogout=()=>{
        dispatch(logout())
    }
    return (
        <div>
             <div className='profile-tooltip'>
                <a href="https://www.qubisa.com/user/edit-profile"><div className='tooltip-item div-flex div-align-center'>
                    <img src={profile.profilePic!==''?profile.profilePic:DefaultAva} className='profile-circle'/>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <div className=''>
                        <p className='font-nunito margin-0' style={{fontSize:16}}>{profile.name}<br/><span style={{fontSize:12}}>{profile.email!==null&&profile.email}</span></p>
                    </div>
                </div></a>
                <a href="https://www.qubisa.com/user/poinqu"><div className='item-link'>
                    <p className='font-nunito margin-0' style={{fontSize:16}}>PoinQu</p>
                </div></a>
                <a href="https://www.qubisa.com/order/history"><div className='item-link'>
                    <p className='font-nunito margin-0' style={{fontSize:16}}>Riwayat Transaksi</p>
                </div></a>
                <a href="https://www.qubisa.com/webinar/history"><div className='item-link'>
                    <p className='font-nunito margin-0' style={{fontSize:16}}>Riwayat Webinar</p>
                </div></a>
                <a href="https://instructor.qubisa.com/course"><div className='item-link'>
                    <p className='font-nunito margin-0' style={{fontSize:16}}>Jadi Instruktur</p>
                </div></a>
                <a href="https://www.qubisa.com/support"><div className='item-link'>
                    <p className='font-nunito margin-0' style={{fontSize:16}}>Bantuan</p>
                </div></a>
                <a href="#" onClick={onLogout}><div className='item-link'>
                    <p className='font-nunito margin-0' style={{fontSize:16}}>Keluar</p>
                    <br/>
                </div></a>
            </div>
        </div>
    )
}
